import { Link } from 'react-router-dom';

export default function Footer() {
  const socialLinks = [
    { icon: 'ri-facebook-fill', url: 'https://www.facebook.com/bennlegacy1', label: 'Facebook' },
    { icon: 'ri-instagram-line', url: 'https://www.instagram.com/bennylegacy/', label: 'Instagram' },
    { icon: 'ri-linkedin-fill', url: 'https://www.linkedin.com/in/benny-legacy-678079111/', label: 'LinkedIn' },
    { icon: 'ri-youtube-fill', url: 'https://www.youtube.com/@bennylegacy154', label: 'YouTube' },
  ];

  return (
    <footer style={{ background: '#1a1a1a', borderTop: '3px solid #B8860B' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 sm:gap-10 mb-10">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://static.readdy.ai/image/73df10f1d2f13e308059e9f42ef7d721/1a1b91da26efffeb07731f8f238e690f.png"
                alt="Limitless Legacy Fitness"
                className="w-9 h-9 object-contain"
              />
              <span className="font-bold text-sm" style={{ background: 'linear-gradient(90deg, #B8860B, #F5D76E)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
                Limitless Legacy Fitness
              </span>
            </div>
            <p className="text-sm leading-relaxed" style={{ color: '#888888' }}>
              Empowering individuals through nutrition, movement, and personal development to build a lasting legacy.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold mb-4 uppercase tracking-widest" style={{ color: '#F5D76E' }}>Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/about"
                  className="text-sm transition-colors duration-200 cursor-pointer"
                  style={{ color: '#888888' }}
                  onMouseEnter={e => (e.currentTarget.style.color = '#F5D76E')}
                  onMouseLeave={e => (e.currentTarget.style.color = '#888888')}
                >
                  About Benny
                </Link>
              </li>
              {[
                { href: '#services', label: 'Our Services' },
                { href: '#testimonials', label: 'Testimonials' },
                { href: '#booking', label: 'Book a Session' },
              ].map((item, i) => (
                <li key={i}>
                  <a
                    href={item.href}
                    className="text-sm transition-colors duration-200 cursor-pointer"
                    style={{ color: '#888888' }}
                    onMouseEnter={e => (e.currentTarget.style.color = '#F5D76E')}
                    onMouseLeave={e => (e.currentTarget.style.color = '#888888')}
                  >
                    {item.label}
                  </a>
                </li>
              ))}
              <li>
                <Link
                  to="/blog"
                  className="text-sm transition-colors duration-200 cursor-pointer"
                  style={{ color: '#888888' }}
                  onMouseEnter={e => (e.currentTarget.style.color = '#F5D76E')}
                  onMouseLeave={e => (e.currentTarget.style.color = '#888888')}
                >
                  Blog &amp; Tips
                </Link>
              </li>
              <li>
                <Link
                  to="/programs"
                  className="text-sm transition-colors duration-200 cursor-pointer"
                  style={{ color: '#888888' }}
                  onMouseEnter={e => (e.currentTarget.style.color = '#F5D76E')}
                  onMouseLeave={e => (e.currentTarget.style.color = '#888888')}
                >
                  Programs &amp; Pricing
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold mb-4 uppercase tracking-widest" style={{ color: '#F5D76E' }}>Follow Us</h4>
            <div className="flex gap-3 flex-wrap">
              {socialLinks.map((s, i) => (
                <a
                  key={i}
                  href={s.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  className="w-9 h-9 flex items-center justify-center rounded-full transition-all duration-300 cursor-pointer"
                  style={{ background: '#2a2a2a', border: '1px solid #B8860B', color: '#B8860B' }}
                  onMouseEnter={e => {
                    (e.currentTarget as HTMLAnchorElement).style.background = '#C8102E';
                    (e.currentTarget as HTMLAnchorElement).style.borderColor = '#C8102E';
                    (e.currentTarget as HTMLAnchorElement).style.color = '#ffffff';
                  }}
                  onMouseLeave={e => {
                    (e.currentTarget as HTMLAnchorElement).style.background = '#2a2a2a';
                    (e.currentTarget as HTMLAnchorElement).style.borderColor = '#B8860B';
                    (e.currentTarget as HTMLAnchorElement).style.color = '#B8860B';
                  }}
                >
                  <i className={`${s.icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="pt-6 flex flex-col sm:flex-row justify-between items-center gap-3" style={{ borderTop: '1px solid #2a2a2a' }}>
          <p className="text-xs text-center sm:text-left" style={{ color: '#555555' }}>
            Copyright &copy; 2026 Limitless Legacy Fitness and Health INC. All Rights Reserved.
          </p>
          <div className="flex items-center gap-4">
            <Link
              to="/privacy-policy"
              className="text-xs cursor-pointer transition-colors duration-200 whitespace-nowrap"
              style={{ color: '#888888' }}
              onMouseEnter={e => (e.currentTarget.style.color = '#F5D76E')}
              onMouseLeave={e => (e.currentTarget.style.color = '#888888')}
            >
              Privacy Policy
            </Link>
            <span style={{ color: '#444' }}>|</span>
            <Link
              to="/terms"
              className="text-xs cursor-pointer transition-colors duration-200 whitespace-nowrap"
              style={{ color: '#888888' }}
              onMouseEnter={e => (e.currentTarget.style.color = '#F5D76E')}
              onMouseLeave={e => (e.currentTarget.style.color = '#888888')}
            >
              Terms &amp; Conditions
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}